import type { SidebarOptionKind } from './sidebar/types'
import type { Dispatch, ElementType, ReactNode, SetStateAction } from 'react'

import { useCallback, createContext, useContext, useMemo, useState } from 'react'

type SidebarOptions = SidebarOptionKind | null | 'closed'

interface SidebarContextT {
  state: SidebarOptions
  setState: Dispatch<SetStateAction<SidebarOptions>>
  close: () => void
}

let noop = (): void => { /* noop */ }

export let SidebarContext = createContext<SidebarContextT>({
  state: null,
  setState: noop,
  close: noop
})

interface Props {
  children: ReactNode
}

export function SidebarProvider ({ children }: Props): JSX.Element {
  let [ state, setState ] = useState<SidebarOptions>(null)

  let close = useCallback(() => {
    setState(null)
  }, [])

  let value = useMemo(() => ({ state, setState, close }), [ state, close ])

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  )
}

export function useSidebar (): SidebarContextT {
  return useContext(SidebarContext)
}

export function withLegacySidebar<T extends object> (Component: ElementType) {
  return function WithLegacySidebar (props: T): JSX.Element {
    const { state, setState } = useSidebar()

    return (
      <Component
        {...props}
        setSidebarState={setState}
        sidebarState={state}
      />
    )
  }
}
